import * as actions from "./actionsTypes";

const initialData = {
  loaderStatus: false,
  loaderStatuss: false,
  saveLoaderStatus: false,
  statuss: null,
  status: null,
  statusFaild: null,
  statussFaild: null,
  statusFormFaild: null  
};

export default function SancionesStatusReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADER_STATUS:
      return { ...state, loaderStatus: action.payload };
    case actions.LOADER_STATUSS:
      return { ...state, loaderStatuss: action.payload };
    case actions.SAVE_LOADER_STATUS:
      return { ...state, saveLoaderStatus: action.payload };
    case actions.GET_STATUSS:
      return { ...state, statuss: action.payload };
    case actions.GET_STATUS:
      return { ...state, status: action.payload };
    case actions.FAILD_STATUS:
      return { ...state, statusFaild: action.payload }
    case actions.FAILD_STATUSS:
      return { ...state, statussFaild: action.payload };
    case actions.FORM_STATUS_FAILD:
      return { ...state, statusFormFaild: action.payload };
    default:
      return state;
  }
}